export default "__VITE_ASSET__Bad3t4MI__"